import { DEFAULT_FONT_FAMILY } from '../../../../../constants';

export const CHART_HEIGHT = 160;
export const SVG_HEIGHT = 140;

export const getSvgHeightPaddingHeight = (isMobile: boolean) => (isMobile ? 120 : 140);

export const barColorsEnum = {
  Primary: '#6AE4FF',
  Secondary: '#FF7E36',
  Tertiary: '#FF6AC3',
};

export const xAxisStyle = {
  axis: {
    stroke: 'white',
    strokeDasharray: '2,10',
  },
  tickLabels: {
    display: 'none',
  },
};

export const yAxisRightStyle = {
  axis: { stroke: 'none' },
  tickLabels: {
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: 14,
    fill: '#CBD5E0',
  },
};

export const emptyDataKey = -1;

export const emptyIncomeData = { revenue: 0, netIncome: 0, key: emptyDataKey, period: '' };
export const emptyCashFlowData = { operating: 0, investing: 0, financing: 0, key: emptyDataKey, period: '' };
export const emptyBalanceData = { totalAssets: 0, totalLiabilities: 0, key: emptyDataKey, period: '' };
